import { useSession } from '../hooks/use-session.js';
import { AuthScreen } from './AuthScreen.jsx';
import { BrandedLoading } from './BrandedLoading.jsx';

/**
 * Decides whether to show the application or the sign-in screen.
 *
 * Three branches, one per session state, and no default that guesses. While the answer
 * is unknown it shows a loading state rather than flashing the sign-in screen at
 * someone who is already signed in, and rather than flashing the dashboard at someone
 * who is not.
 *
 * @param {{children: import('react').ReactNode}} props
 */
export function AuthGate({ children }) {
  const { status, user, retrying } = useSession();

  if (status === 'loading') {
    // Distinct from the very first attempt, which already reads as "loading" on its
    // own: after a failed attempt, the same unchanging label sat on screen through
    // however many silent 5-second retries followed, with nothing to say a retry was
    // even happening while the network tab kept showing calls going out.
    return <BrandedLoading displayName={user?.displayName}
      label={retrying ? "Having trouble reaching the server. Trying again…" : undefined} />;
  }

  if (status === 'signed-out') return <AuthScreen />;

  return children;
}
